import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  Outlet,
  ScrollRestoration,
} from "react-router-dom";
import Pocetna from "./components/pocetna";
import Dvorane from "./components/dvorane";
import Kampovi from "./components/kampovi";
import Obavijesti from "./components/obavijesti";
import Galerija from "./components/galerija";
import { DVORANE_SHEET_URL, parseDvoraneCSV } from "./components/dvoraneData";
import { parsirajCSV } from "./components/csv";
import "./styles/App.css";

function RootLayout() {
  return (
    <>
      <Outlet />
      <ScrollRestoration getKey={(location) => location.pathname} />
    </>
  );
}


function App() {
  const [obavijesti, setObavijesti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dvorane, setDvorane] = useState([]);
  const [loadingDvorane, setLoadingDvorane] = useState(true);


  useEffect(() => {
    const sheetURL =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vS5w6Weikp2R7UDpRAPPLYdlgDwfA8u5kaVw-Skg6Aa4P-yrdF7sG9dINZnZTOisg4imIWcm8O21BMc/pub?output=csv";

    fetch(sheetURL)
      .then((res) => res.text())
      .then((csvTekst) => {
        const redci = parsirajCSV(csvTekst).slice(1);
        const obradjeneObavijesti = redci
          .map(([datum = "", naslov = "", tekst = "", slika = ""]) => ({
            datum,
            naslov,
            tekst,
            slika,
          }))
          .filter((o) => o.naslov)
          .reverse();

        setObavijesti(obradjeneObavijesti);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Greška:", err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetch(DVORANE_SHEET_URL)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Tablica nije dostupna: ${res.status}`);
        }

        return res.text();
      })
      .then((csvTekst) => {
        setDvorane(parseDvoraneCSV(csvTekst));
      })
      .catch((err) => {
        console.error("Greška kod dvorana:", err);
        setDvorane([]);
      })
      .finally(() => {
        setLoadingDvorane(false);
      });
  }, []);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/pocetna" />,
        },
        {
          path: "pocetna",
          element: (
            <Pocetna
              obavijesti={obavijesti}
              loading={loading}
              dvorane={dvorane}
              loadingDvorane={loadingDvorane}
            />
          ),
        },
        {
          path: "dvorane",
          element: <Dvorane dvorane={dvorane} loading={loadingDvorane} />,
        },
        {
          path: "kampovi",
          element: <Kampovi />,
        },
        {
          path: "galerija",
          children: [
            {
              index: true,
              element: <Galerija />,
            },
            {
              path: ":schoolId",
              element: <Galerija />,
            },
          ],
        },
        {
          path: "obavijesti",
          element: <Obavijesti obavijesti={obavijesti} loading={loading} />,
        },
        {
          path: "*",
          element: <Navigate to="/pocetna" />,
        },
      ],
    },
  ]);

  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

export default App;
